import BookingService from 'src/lib/api/booking.service';

export async function searchBookings({ commit }, { params }) {
  const response = await BookingService.searchBookings({ params });
  if (response.status === 200) {
    commit('updateBookings', { bookings: response.data.data });
    commit('updateMeta', {
      meta: {
        next: response.data.next,
        previous: response.data.previous,
        rowCount: response.data.total,
      },
    });
  }
}

export async function getBooking(context, { id }) {
  const response = await BookingService.getBooking({ id });
  if (response.status === 200) {
    return response.data;
  }

  return null;
}

export async function createBooking(context, { booking }) {
  await BookingService.createBooking({ booking });
}

export async function updateBookingStatus(context, { id, status }) {
  await BookingService.updateBookingStatus({ id, status });
}

export async function searchTimeslots({ commit }, { params }) {
  const response = await BookingService.searchTimeslots({ params });
  if (response.status === 200) {
    commit('updateSlots', { slots: response.data });
  }
}
